import Box from "@mui/material/Box";
import "./ShortPreview.css";

const ShortPreview = ({ question }) => {
  //const { isActive } = question;

  return (
    <>
      <Box className="short-question__preview">
        <p>Short Answer</p>
        <div className="short-question__line" />
      </Box>
    </>
  );
};

export default ShortPreview;
